import { render, staticRenderFns } from "./bookmark-row.vue?vue&type=template&id=15066926&scoped=true&"
import script from "./bookmark-row.vue?vue&type=script&lang=ts&"
export * from "./bookmark-row.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-row.vue?vue&type=style&index=0&id=15066926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15066926",
  null
  
)

export default component.exports